import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { field, countryIs, REQUIRED, OPTIONAL } from "./utils";
import * as TURKEY from "../../onboarding/profile-info/form/tr/constants.tr";

export const turkeyFields = {
  trGender: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "trGender",
    label: "Gender",
    placeholder: "Select Gender",
    message:
      "For the time being, we are limited to these two options. We recognize that life is more nuanced and are actively exploring ways to fully reflect everyone's experiences.",
    options: TURKEY.GENDER_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("TR"),
    },
    value: () => "",
  }),

  trMaritalStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "trMaritalStatus",
    label: "Marital Status",
    placeholder: "Select Marital Status",
    options: TURKEY.MARITAL_STATUS_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("TR"),
    },
    value: () => "",
  }),

  trNumChildrenBelow6: field({
    type: FieldTypes.number,
    informationType: "identification",
    name: "trNumChildrenBelow6",
    label: "Number of Children Below 6",
    validations: {
      ...REQUIRED,
      number: {
        min: {
          value: 0,
          message: "Must be a greater than or equal to 0",
        },
      },
    },
    scenarios: {
      onboarding: countryIs("TR"),
    },
    value: () => "0",
    serialize: (value) => parseInt(value, 10),
  }),

  trNumChildren6OrAbove: field({
    type: FieldTypes.number,
    informationType: "identification",
    name: "trNumChildren6OrAbove",
    label: "Number of Children 6 or Above",
    validations: {
      ...REQUIRED,
      number: {
        min: {
          value: 0,
          message: "Must be a greater than or equal to 0",
        },
      },
    },
    scenarios: {
      onboarding: countryIs("TR"),
    },
    value: () => "0",
    serialize: (value) => parseInt(value, 10),
  }),

  trIncomeTaxExempt: field({
    type: FieldTypes.checkbox,
    informationType: "identification",
    name: "trIncomeTaxExempt",
    label: "Income Tax Exempt",
    description: "Do you have some special consideration for tax exemptions?",
    validations: {
      required: {
        // using the REQUIRED constant makes this field uncheckable until previous fields are filled so we provide a duplicate object here
        enabled: true,
        message: "This field is required.",
      },
    },
    scenarios: {
      onboarding: countryIs("TR"),
    },
    value: () => false,
  }),

  trTaxDeductionCode: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "trTaxDeductionCode",
    label: "Tax Deduction Code",
    validations: OPTIONAL,
    scenarios: {
      onboarding: countryIs("TR"),
    },
    value: () => "",
  }),
};
